import KeenSlider from "keen-slider";

let dots;

const navigation = (slider) => {
	/* console.log(slider); */
	dots = document.querySelectorAll(
		".global-reviews__slider-controls .slider-controls__dot"
	);
	dots.forEach((el, i) => (el.dataset.index = i));
	dots[0].dataset.active = true;
	//
	const leftBtn = document.querySelector(
		".global-reviews__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=left]"
	);
	const altLeftBtn = document.querySelector(
		".global-reviews__alt-slider-controls .circle-arrow-btn[data-dir=left]"
	);
	const rightBtn = document.querySelector(
		".global-reviews__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=right]"
	);
	const altRightBtn = document.querySelector(
		".global-reviews__alt-slider-controls .circle-arrow-btn[data-dir=right]"
	);
	//
	leftBtn.addEventListener("click", slider.prev);
	altLeftBtn.addEventListener("click", slider.prev);
	rightBtn.addEventListener("click", slider.next);
	altRightBtn.addEventListener("click", slider.next);
	slider.on("slideChanged", updateDots);
};

const updateDots = (e) => {
	dots.forEach((el) => (el.dataset.active = false));
	dots[e.track.details.rel].dataset.active = true;
};

export default function () {
	if (document.querySelector("[data-global-reviews-carousel]")) {
		new KeenSlider(
			"[data-global-reviews-carousel]",
			{
				loop: true,
				slides: {
					perView: 1,
					spacing: 24,
				},
				breakpoints: {
					"(min-width: 540px)": {
						slides: {
							perView: 2,
						},
					},
					"(min-width: 860px)": {
						slides: {
							perView: 3,
							spacing: 44,
						},
					},
				},
			},
			[navigation]
		);
	}
}
